import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Title = styled.div({
    display: "inline-block",
});

export const Root = styled.div(props => ({
    fontSize: "20px",
    lineHeight: "34px",
    color: theme(props).typography.primary.color,
    marginBottom: 10,
    minHeight: 34,
    width: "75%",
}));
